app.controller("AddLecturerController", ["$scope", "$uibModalInstance", "StaticData", "Lecturer", "Users", "toastr",
    function ($scope, $uibModalInstance, StaticData, Lecturer, Users, toastr) {
        $scope.format = "dd-MM-yyyy";
        $scope.chosenUser = "";

        $scope.lecturer = {
            userConfig: {}
        };

        $scope.popup1 = {
            opened: false
        };

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("lecturer_ranks").then(function (ranks) {
            $scope.ranks = [{name: "თანამდებობა"}].concat(ranks);
            $scope.ranksMap = _.keyBy($scope.ranks, '_id');
        });

        $scope.getUsers = function (name) {
            if (name.length < 1) {
                return [];
            }
            return Users.list({
                query: name
            }).then(function (data) {
                return data.docs;
            });
        };

        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            "clearText": "წაშლა",
            "clear-text": "წაშლა",
            closeText: "დახურვა",
            currentText: "დღეს",
            maxDate: new Date(2020, 5, 22),
            minDate: new Date(),
            startingDay: 1
        };

        $scope.searchPerson = function () {
            $scope.addNewUser = false;
            Users.search($scope.lecturer.personalNo).then(function (user) {
                if (user) {
                    $scope.lecturer = user;
                } else {
                    $scope.lecturer = {
                        userConfig: {}
                    };
                }
            })
        };

        $scope.addNewPerson = function () {
            $scope.addNewUser = true;
            $scope.lecturer = {
                userConfig: {}
            };
        };

        $scope.create = function () {
            var id = $scope.chosenUser._id;
            Lecturer.create({
                user: id,
                faculty: $scope.faculty,
                rank: $scope.rank
            }).then(function (resp) {
                 toastr.success('ლექტორი დამატებულია');
                 $uibModalInstance.close();
            }).catch(function (err) {
                if (err.status == 400) {
                    toastr.error('', 'მომხმარებელს უკვე აქვს ლექტორის აქტიური პროფილი.');
                }
            });
        };

        // $scope.create = function () {
        //     console.dir($scope.lecturer);
        //     console.dir(JSON.stringify($scope.lecturer));
        //     //return;
        //     if ($scope.lecturer._id) {
        //         Lecturer.create($scope.lecturer._id, {}).then(function (lecturer) {
        //         })
        //     } else {
        //         // TODO add user, then profile
        //     }
        //     return;
        //     Lecturer.create({
        //         personalNo: "a",
        //         firstName: "a",
        //         lastName: "a",
        //         birthDate: new Date(),
        //         password: "as",
        //         userConfig: {},
        //         image: "",
        //         phone: "",
        //         citizenship: ""
        //     }).then(function (resp) {
        //     });
        //     return;
        //     if (!($scope.name.length && $scope.description.length)) {
        //         return;
        //     }
        //     Access.createRole({
        //         name: $scope.name,
        //         description: $scope.description
        //     }).then(function (created) {
        //         if (created) {
        //             $uibModalInstance.close();
        //         }
        //     })
        // };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
